class TimeListHandler extends TimeList {
    constructor(...args) {
        super(...args);
        this.timeListInputSelector = '.js-radio-time-input'
        this.initListeners()
    }

    initListeners() {
        this.initClickListener()
    }

    initClickListener() {
        $(this.element).on('click', this.timeListInputSelector, this.triggerChoiceTime.bind(this))
    }

    triggerChoiceTime(e) {
        const value = e.target.value
        const choiceTimeEvent = new CustomEvent('time:choice', {
            bubbles: true, detail: {
                value
            }
        });
        this.element[0].dispatchEvent(choiceTimeEvent);
    }
}
